// client/src/pages/Login.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import LoginForm from '../components/LoginForm';
import '../styles/Login.css';

function Login() {
  return (
    <>
      <Helmet>
        <title>Anmelden | DynaStoxx</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1>Willkommen zurück!</h1>
            <p className="text-muted">Melde dich an, um auf dein Portfolio zuzugreifen.</p>
          </div>
          <LoginForm />
        </div>
      </div>
    </>
  );
}

export default Login;

